import classNames from "classnames";
import { useEffect } from "react";
import * as React from "react";
import tryLazyLoad from "@libs/utils/lazyLoad";
import styles from "./index.module.css";

type LazyImageProps = {
  className?: string;
  alt?: string;
  src?: string;
  srcset?: string;
  sizes?: string;
  width: number;
  height: number;
};

// SEE: https://github.com/verlok/vanilla-lazyload#usage-with-react
const LazyImage: React.FC<LazyImageProps> = ({
  className = "",
  alt = "",
  src,
  srcset,
  sizes,
  width,
  height,
}) => {
  const paddingBottom = (height / width) * 100;

  useEffect(() => {
    tryLazyLoad();
  });

  return (
    <div
      className={classNames(styles.root, className)}
      style={{ paddingBottom: `${paddingBottom}%` }}
    >
      <img
        alt={alt}
        className={classNames(styles.image, "lazy")}
        data-src={src}
        data-srcset={srcset}
        data-sizes={sizes}
      />
    </div>
  );
};

export default LazyImage;
